import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader';
import PageHeadline from '../../components/PageHeadline';

/**
 * What a tenant without the `accessManagement` add-on sees at the
 * access-management route (ADR-0001 Amendment 4).
 *
 * Since Amendment 5 (2026-09-22) nothing in the sidebar links here: a tenant
 * that operates no device has no access-management entry at all. The page
 * stays because the route stays reachable — a deep link, a bookmark, a tenant
 * switch on an open page — and what it must not do is answer that with a
 * refusal. So it still explains what access management does before naming the
 * way to get it, rather than telling a tenant they are not entitled.
 *
 * It grants nothing. Every device endpoint behind the real page remains
 * entitlement-gated server-side; this is a description, not a door.
 */
export default function AccessManagementUpsell() {
    const { t } = useTranslation();
    const supportEmail = 'support@kolula.com';

    return (
        <div>
            <PageHeader>
                <PageHeadline>{t('access_management_upsell.title')}</PageHeadline>
            </PageHeader>

            <section
                className={'bg-text-contrast rounded-[5px] shadow-sm px-5 py-4 max-w-2xl'}
            >
                <p className={'text-sm text-foreground'}>
                    {t('access_management_upsell.what_it_is')}
                </p>

                <ul
                    className={'mt-3 list-disc pl-5 text-sm text-foreground/60'
                        + ' flex flex-col gap-1'}
                >
                    <li>{t('access_management_upsell.point_codes')}</li>
                    <li>{t('access_management_upsell.point_devices')}</li>
                    <li>{t('access_management_upsell.point_unattended')}</li>
                </ul>

                <p className={'mt-4 text-sm text-foreground'}>
                    {t('access_management_upsell.not_booked')}
                </p>

                <p className={'mt-2 text-sm text-foreground'}>
                    {t('access_management_upsell.get_in_touch')}{' '}
                    <a
                        className={'text-primary underline'}
                        href={`mailto:${supportEmail}`}
                    >
                        {supportEmail}
                    </a>
                </p>

                <p className={'mt-4 text-sm text-foreground/60'}>
                    {t('access_management_upsell.baseline_note')}
                </p>
            </section>
        </div>
    );
}
